import { requestForApi } from "../../utils/httpUtil";

export async function queryAncientInfo(pageSize: number, current: number, key?: string) {
    const resp = await requestForApi(`/api/v1/garden/ancients/search?pageSize=${pageSize}&current=${current}&key=${key ? key : ''}`,
        {
            method: 'GET',
        }
    );
    if (resp && resp.result) {
        return Promise.resolve({
            data: resp.data && resp.data.list ? resp.data.list : [],
            success: true,
            total: resp.data?.pagination?.total,
            pageSize: resp.data?.pagination?.pageSize,
            current: resp.data?.pagination?.current,
        });
    }
    return Promise.resolve({
        data: [],
        success: false,
        total: 0,
        pageSize: 20,
        current: 1,
    });
}

/**
 *
 * @param id 根据ID拿到古树信息
 */
export async function queryAncientInfoById(id: string) {
    const res = await requestForApi(`/api/v1/garden/ancients/${id}`, {
        method: 'GET',
    });
    if (!res.result) {
        throw new Error(res.message);
    }
    return res.data.obj;
}


export async function queryComplaint(pageSize: number, current: number) {
    const resp = await requestForApi(`/api/v1/garden/complaints/search?pageSize=${pageSize}&current=${current}`,
        {
            method: 'GET',
        },
    );
    if (resp && resp.result) {
        return Promise.resolve({
            data: resp.data && resp.data.list ? resp.data.list : [],
            success: true,
            total: resp.data?.pagination?.total,
            pageSize: resp.data?.pagination?.pageSize,
            current: resp.data?.pagination?.current,
        });
    }
    return Promise.resolve({
        data: [],
        success: false,
        total: 0,
        pageSize: 20,
        current: 1,
    });
}